import { useEffect } from "react";

export const TURNSTILE_SITE_KEY = "0x4AAAAAACY6SAO6JFtkjRB3"
export const LOCALHOST_SITE_KEY = "0x4AAAAAACZZMknjucr67Wiv"

export const useTurnstile = () => {
	useEffect(() => {
			// Load Turnstile script
			const script = document.createElement('script');
			script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
			script.async = true;
			document.head.appendChild(script);
			
			return () => {
				// Cleanup script on unmount
				const existingScript = document.querySelector('script[src="https://challenges.cloudflare.com/turnstile/v0/api.js"]');
				if (existingScript) {
					document.head.removeChild(existingScript);
				}
			};
		}, []);
}